export default "__VITE_PUBLIC_ASSET__4bcb3788__"